import { lazy } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { RoleGuard } from "@/auth/guard";
import { UserRole } from "@/auth/types";

const Attendance = lazy(() => import("@/modules/admin/pages/Attendance"));
const Tasks = lazy(() => import("@/modules/admin/pages/Tasks"));
const TasksSingle = lazy(() => import("@/modules/admin/pages/TaskSingle"));
const ReportTable = lazy(() => import("@/modules/admin/pages/Reports"));
const MegaProject = lazy(() => import("@/modules/admin/pages/MegaProjects"));
const Ideas = lazy(() => import("@/modules/admin/pages/Ideas"));
const IdeasSinglePage = lazy(() => import("@/modules/admin/pages/IdeasSingle"));
const ChatPage = lazy(() => import("@/modules/admin/pages/Chat"));
const ChatMessages = lazy(() => import("@/modules/admin/pages/ChatMessages"));
const LeaderList = lazy(() => import("@/modules/admin/pages/LeaderList"));
const LeaderProfile = lazy(() => import("@/modules/admin/pages/LeaderProfile"));
const NewChatMessages = lazy(
  () => import("@/modules/admin/pages/NewChatMessages"),
);
const Monitoring = lazy(() => import("@/modules/admin/pages/Monitoring"));
const MyVillageRoot = lazy(
  () => import("@/pages/Protected/Yetakchi/neighorbood/MyVillage"),
);

export const yetakchiAdmin: RouteObject[] = [
  {
    path: "admin",
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "attendance",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <Attendance />
          </RoleGuard>
        ),
      },
      {
        path: "tasks",
        element: <Tasks />,
      },
      {
        path: "tasks/:id",
        element: <TasksSingle />,
      },
      {
        path: "reports",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[
              UserRole.DistrictAdmin,
              UserRole.InstitutionAdmin,
            ]}
          >
            <ReportTable />
          </RoleGuard>
        ),
      },
      {
        path: "mega-projects",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <MegaProject />
          </RoleGuard>
        ),
      },
      {
        path: "ideas",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <Ideas />
          </RoleGuard>
        ),
      },
      {
        path: "user-ideas/:id",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <IdeasSinglePage />
          </RoleGuard>
        ),
      },
      {
        path: "leaders",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <LeaderList />
          </RoleGuard>
        ),
      },
      {
        path: "leader/:id",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <LeaderProfile />
          </RoleGuard>
        ),
      },
      {
        path: "chat",
        element: (
          <RoleGuard
            redirectTo="/yetakchi/admin/tasks"
            restrictedRoles={[UserRole.InstitutionAdmin]}
          >
            <ChatPage />
          </RoleGuard>
        ),
        children: [
          {
            path: ":id/:user_id",
            element: (
              <RoleGuard
                redirectTo="/yetakchi/admin/tasks"
                restrictedRoles={[UserRole.InstitutionAdmin]}
              >
                <ChatMessages />
              </RoleGuard>
            ),
          },
          {
            path: "new/:user_id",
            element: (
              <RoleGuard
                redirectTo="/yetakchi/admin/tasks"
                restrictedRoles={[UserRole.InstitutionAdmin]}
              >
                <NewChatMessages />
              </RoleGuard>
            ),
          },
        ],
      },
      {
        path: "monitoring",
        element: (
          <RoleGuard
            restrictedRoles={[UserRole.InstitutionAdmin]}
            redirectTo="/yetakchi/admin/tasks"
          >
            <Monitoring />
          </RoleGuard>
        ),
      },
      // --- InstitutionAdmin-only: Balance ---
      // {
      //   path: "balance",
      //   children: [
      //     {
      //       index: true,
      //       element: (
      //         <RoleGuard
      //           restrictedRoles={[
      //             UserRole.DepartmentAdmin,
      //             UserRole.DistrictAdmin,
      //             UserRole.RegionAdmin,
      //           ]}
      //           redirectTo="/yetakchi/admin"
      //         >
      //           <Balance />
      //         </RoleGuard>
      //       ),
      //     },
      //     {
      //       path: "stats/:category",
      //       element: (
      //         <RoleGuard
      //           restrictedRoles={[
      //             UserRole.DepartmentAdmin,
      //             UserRole.DistrictAdmin,
      //             UserRole.RegionAdmin,
      //           ]}
      //           redirectTo="/yetakchi/admin"
      //         >
      //           <StatsDetailPage />
      //         </RoleGuard>
      //       ),
      //     },
      //   ],
      // },
      {
        path: "monitoring/neighborhood/:id",
        element: (
          <RoleGuard
            restrictedRoles={[UserRole.InstitutionAdmin]}
            redirectTo="/yetakchi/admin/tasks"
          >
            <MyVillageRoot />
          </RoleGuard>
        ),
      },
    ],
  },
];
